import React, { useRef, useState } from "react";
import { signInWithEmailAndPassword } from "firebase/auth";
import { useNavigate } from "react-router-dom";
// Utils
import { auth } from "../../utils/firebase/firebase";
import { cLog } from "../../utils/log_util";
// Styles
import styles from "./login.module.css";
import VerticalFormInputField from "../../components/form-input-field/VerticalFormInputField";
import Card from "../../components/card/Card";

function Login() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const navigate = useNavigate();

  // Ref
  const emailRef = useRef(null);
  const passwordRef = useRef(null);

  const handleEmail = (e) => {
    setEmail(e.target.value);
  };
  const handlePassword = (e) => {
    setPassword(e.target.value);
  };

  const handleLogin = async (e) => {
    e.preventDefault();
    try {
      await signInWithEmailAndPassword(auth, email, password)
        .then((cred) => {
          alert("Yay! You are logged in!");
          navigate("/dashboard");
        })
        .catch((err) => {
          cLog(err);
          setError(err.message);
        });
    } catch (err) {
      setError(err.message);
    }
  };

  return (
    <section className={`${styles.loginContainer} boxShadow`}>
      <h2 style={{ textAlign: "center" }}>Login</h2>
      {error && (
        <p>
          Error: <span className={styles.errorText}>{error}</span>
        </p>
      )}
      <div className={styles.loginForm}>
        <VerticalFormInputField
          title="Email"
          hint="abc@example.com"
          type="email"
          value={email}
          onChange={handleEmail}
          ref={emailRef}
          className={styles.loginField}
          required={true}
        />

        <VerticalFormInputField
          title="Password"
          hint="Password"
          type="password"
          value={password}
          onChange={handlePassword}
          ref={passwordRef}
          className={styles.loginField}
          required={true}
        />

        <Card
          className={`${styles.submitBtn}`}
          backgroundColor="#931b1c"
          onClick={(e) => handleLogin(e)}
        >
          <p className={styles.submitBtnTxt}>Submit</p>
        </Card>
      </div>
    </section>
  );
}

export default Login;
